// Klawisze przewijania (PgUp/PgDn, spacja, strzałki, Home/End) przewijają element z fokusem.
// W layoucie przewija się <main> (overflow-y-auto), a nie cała strona - bez fokusu (fokus na <body>)
// klawisze nic nie robiły, dopóki user nie kliknął w treść. Dajemy fokus na <main>
// (tabindex="-1" dokładamy w locie), ale tylko gdy nikt inny go nie wziął (autofocus, modal).
// Na razie używane tylko w widoku zadania (kontroler organize--task-keyboard-scroll).
export function focusMainForKeyboardScroll(doc, main) {
  if (!main) return false

  const active = doc.activeElement
  if (active && active !== doc.body && active !== doc.documentElement) return false

  if (!main.hasAttribute("tabindex")) main.setAttribute("tabindex", "-1")
  // preventScroll - nie ruszamy pozycji przywróconej przez data-remember-position
  main.focus({ preventScroll: true })
  return true
}
